import clsx from "clsx"
import { DM_Serif_Display, Lekton, Manrope } from "next/font/google"

const sans = Manrope({
  subsets: ["latin"],
  variable: "--font-sans",
})

const serif = DM_Serif_Display({
  subsets: ["latin"],
  variable: "--font-serif",
  weight: ["400"],
})

const mono = Lekton({
  subsets: ["latin"],
  variable: "--font-mono",
  weight: ["400"],
})

export const fontClassName = clsx(sans.className, sans.variable, serif.variable, mono.variable)
